import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Loading } from '../components';
import { useAuthStore } from './useAuthStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { user, loading, isAuthenticated, hasCheckedAuth, getMe } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !hasCheckedAuth) {
      getMe();
    }
  }, [loading, hasCheckedAuth, getMe]);

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated || !user) {
    if (location.pathname !== '/login') {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  return <>{children}</>;
};
